import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV2Cgi, RetCode } from "../data-source/network-request";
/**
 * 获取文档权限
 */
export function fetchAttribute(params) {
  return new AttributeRequest(params).send();
}
export var AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType[AttributeType["File"] = 2] = "File";
  AttributeType[AttributeType["Folder"] = 3] = "Folder";
  return AttributeType;
}({});
/**
 * 修改文件名称
 */
export var AttributeRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(AttributeRequest, _DriveRequest);
  var _super = _createSuper(AttributeRequest);
  function AttributeRequest() {
    _classCallCheck(this, AttributeRequest);
    return _super.apply(this, arguments);
  }
  _createClass(AttributeRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", requestV2Cgi(payload));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "".concat(ATTRIBUTE_URL, "?xsrf=").concat(getXsrfToken()),
        data: {
          docs: params
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if ((response === null || response === void 0 ? void 0 : response.retcode) !== RetCode.Success) {
        throw new DriveApiError({
          name: "AttributeResultError",
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      var attribute_info = response.result.attribute_info;
      var result = new Map();
      Object.keys(attribute_info).forEach(function (id) {
        var info = attribute_info[id];
        var attribute = {
          isAuth: !!info.is_auth,
          isAdmin: !!info.is_admin,
          canAbout: !!info.can_about,
          canAddUser: !!info.can_add_user,
          canComment: !!info.can_comment,
          canCopy: !!info.can_copy,
          canCopyDoc: !!info.can_copy_doc,
          canEdit: !!info.can_edit,
          canExit: !!info.can_exit,
          canExport: !!info.can_export,
          canTransfer: !!info.can_transfer,
          canEditTitle: !!info.can_edit_title,
          canHistory: !!info.can_history,
          canLinkExp: !!info.can_link_exp,
          canPrint: !!info.can_print,
          canRead: !!info.can_read,
          canSearch: !!info.can_search,
          canShare: !!info.can_share,
          canTranslate: !!info.can_translate,
          canViewImage: !!info.can_view_image,
          canWatermark: !!info.can_watermark,
          canEditCollab: !!info.can_edit_collab,
          canViewCollab: !!info.can_view_collab,
          canViewPrivSetting: !!info.can_view_priv_setting,
          canSetEnterRule: !!info.can_set_enter_rule,
          canDelete: !!info.can_delete,
          canMove: !!info.can_move,
          canCreateFile: !!info.can_create_file,
          canCreateFolder: !!info.can_create_folder,
          // @ts-expect-error: 向下兼容
          // @deprecated 不要使用，用 `canHistory` 跟后台协议对齐
          canViewHistory: !!info.can_history,
          // @deprecated 不要使用，用 `canLinkExp` 跟后台协议对齐
          canSetLinkExp: !!info.can_link_exp,
          // @deprecated 不要使用，用 `canRead` 跟后台协议对齐
          canView: !!info.can_read
        };
        result.set(id, attribute);
      });
      return result;
    }
  }]);
  return AttributeRequest;
}(DriveRequest);
var ATTRIBUTE_URL = '/api/permission/batch_get_attribute';
//# sourceMappingURL=attribute.js.map